export default __webpack_public_path__ + "static/media/my_talentx_logo2.5759a9cf.svg";